import { Store } from 'application/store/store.model';
import { ReportState } from './report.model';

class ReportSelectors {
  static state = (store: Store): ReportState => store.report;
}

export default ReportSelectors;
